import axios from "axios";
import _ from "lodash";
import React, { Component } from "react";

import {
  Button,
  Divider,
  Icon,
  Input,
  Modal,
  Pagination,
  Table,
  Tooltip,
} from "antd";

import AddMedicineModal from "./AddMedicineModal";

const { Search } = Input;
const { confirm } = Modal;

class MedicinesList extends Component {
  state = {
    loading: false,
    medList: "",
    medLength: "",
    visibleMed: "",
    data: {},
    put: false,
    id: "",
    searchValue: "",
    confirmLoading: false,
    pageNo: 1,
    size: 10,
  };

  componentDidMount = () => {
    this.getMed();
    this.getMedCount();
  };

  getMed = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/medicines.json?page=1&page_size=1000",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        this.setState({
          medList: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        alert(`${error}: ${error.code}`);
        this.setState({
          loading: false,
        });
      });
  };

  onSearchSubmit = (value) => {
    this.setState({ fetching: true });
    axios({
      method: "get",
      url: `/medicines/lookup_medicines?name=${value}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      console.log(response);
      this.setState({
        medList: response.data,
        fetching: false,
      });
    });
  };

  changeSubmitValue = (event) => {
    if (event.target.value === "") {
      this.getMed();
    }
    this.setState({ searchValue: event.target.value });
  };

  getMedCount = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/medicines/medicines_count",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        medLength: response.data.medicines_count,
        loading: false,
      });
    });
  };

  onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
    this.setState({
      loading: true,
      pageNo: current,
      size: pageSize,
    });
    axios({
      method: "get",
      url: `/medicines.json?page=${current}&page_size=${pageSize}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        medList: response.data,
        loading: false,
      });
    });
  };

  onChange = (current, pageSize) => {
    console.log(current, pageSize);
    this.setState({
      loading: true,
      searchValue: "",
      pageNo: current,
      size: pageSize,
    });
    axios({
      method: "get",
      url: `/medicines.json?page=${current}&page_size=${pageSize}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        medList: response.data,
        loading: false,
      });
    });
  };

  showVisibleMed = () => {
    this.setState({
      visibleMed: true,
    });
  };

  showVisibleMedPut = (id) => {
    const { medList } = this.state;

    const editDetail = medList.filter((med) => med.id === id);
    this.setState({
      visibleMed: true,
      put: true,
      id,
      data: editDetail[0],
    });
  };

  handleVisibleMedCancel = () => {
    this.setState({
      visibleMed: false,
      put: false,
      id: "",
      data: {},
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleMedCreate = () => {
    const { form } = this.formRef.props;
    const { put, id, pageNo, size } = this.state;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }

      this.setState({ confirmLoading: true });
      if (put) {
        axios({
          method: "put",
          url: `/medicines/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: { medicine: values },
        }).then((response) => {
          console.log(response.data);
          form.resetFields();
          this.handleVisibleMedCancel();
          this.onChange(pageNo, size);
          this.setState({ confirmLoading: false });
        });
      } else {
        axios({
          method: "post",
          url: "/medicines.json",
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            medicine: values,
          },
        }).then((response) => {
          console.log(response.data);
          form.resetFields();
          this.handleVisibleMedCancel();
          window.location.reload();
          this.setState({ confirmLoading: false });
        });
      }
    });
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This medicine will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        console.log(id);
        axios({
          method: "delete",
          url: `/medicines/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        })
          .then(() => {
            window.location.reload();
          })
          .catch((error) => console.log(error, "Error"));
      },
      onCancel: () => {},
    });
  };

  render() {
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        width: 100,
        fixed: "left",
        align: "center",
        key: "id",
      },
      {
        title: "Name",
        width: 300,
        fixed: "left",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Form",
        dataIndex: "form",
        key: "form",
      },
      {
        title: "Packaging Use",
        dataIndex: "packaging_use",
        key: "packaging_use",
      },
      {
        title: "Price",
        dataIndex: "price",
        key: "price",
      },
      {
        title: "Manufacturer",
        dataIndex: "manufacturer",
        key: "manufacturer",
      },
      {
        title: "Actions",
        render: (record) => (
          <span>
            <Tooltip placement="top" title="Edit">
              <span
                onClick={() => this.showVisibleMedPut(record.id)}
                role="button"
              >
                <a>
                  <Icon type="edit" />
                </a>
              </span>
            </Tooltip>

            <Divider type="vertical" />

            <Tooltip placement="top" title="Delete">
              <span
                onClick={() => this.showDeleteConfirm(record.id)}
                role="button"
              >
                <a>
                  <Icon style={{ color: "red" }} type="delete" />
                </a>
              </span>
            </Tooltip>
          </span>
        ),
      },
    ];

    const {
      searchValue,
      medList,
      loading,
      medLength,
      visibleMed,
      data,
      confirmLoading,
    } = this.state;

    return (
      <div style={{ overflow: "auto", width: "98%", margin: "auto" }}>
        <h2 style={{ textAlign: "center", marginTop: 20 }}>All Medcines</h2>
        <hr width="200px" />
        <br />

        <div className="d-flex justify-content-center mb-2">
          <Search
            className="m-auto"
            enterButton
            value={searchValue}
            onChange={(event) => this.changeSubmitValue(event)}
            placeholder="Search Medicine"
            onSearch={(value) => this.onSearchSubmit(value)}
            style={{ width: 300 }}
          />

          <br />
          <br />
        </div>

        <Table
          dataSource={medList}
          columns={columns}
          size="small"
          scroll={{ x: 1600 }}
          loading={loading}
          bordered
          pagination={false}
        />
        <br />

        {!searchValue ? (
          <Pagination
            style={{ float: "right" }}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            defaultCurrent={1}
            total={medLength}
            onChange={_.debounce(this.onChange, 300)}
          />
        ) : null}

        <div>
          <Button type="primary" onClick={this.showVisibleMed}>
            Add Medicine
          </Button>
          <AddMedicineModal
            visible={visibleMed}
            data={data}
            wrappedComponentRef={this.saveFormRef}
            onCancel={this.handleVisibleMedCancel}
            onCreate={this.handleMedCreate}
            confirmLoading={confirmLoading}
          />
        </div>
      </div>
    );
  }
}

export default MedicinesList;



// WEBPACK FOOTER //
// ./src/component/AllMedicines/MedicinesList.js